module.exports = __webpack_public_path__ + "img/azad.6f928a7.png";